import * as React from "react";
import PropTypes from "prop-types";

const ToastContext = React.createContext();
ToastContext.displayName = "ToastContext";

const useToastContext = () => React.useContext(ToastContext);

const messagesMap = {
  success: "Action completed successfully!",
  error: "Oops—something went wrong.",
};

const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = React.useState([]);

  const showToast = React.useCallback(
    (message, type = "success", timeout = 8000) => {
      const id = Date.now();
      const display = message ? message : messagesMap[type];
      setToasts((prev) => [...prev, { id, message: display, type }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, timeout);
    },
    [],
  );

  const contextValues = {
    toasts,
    showToast,
  };

  return (
    <ToastContext.Provider value={contextValues}>
      {children}
      <div className="fixed bottom-4 right-4 space-y-2 z-50 toast-container">
        {toasts.map(({ id, message, type }) => (
          <div
            key={id}
            className={`toast px-4 py-2 rounded shadow text-white  ${
              type === "error"
                ? "bg-error"
                : type === "warning"
                  ? "bg-amber-500"
                  : "bg-success"
            }`}
          >
            {message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useToastContext };

export default ToastProvider;
